import { Form, Label } from 'semantic-ui-react';
import styled from 'styled-components';

export const StyledDropdown = styled(Form.Dropdown)`
 .menu {
  max-height: 130px !important;
 }
 width: 50% !important;
`
export const StyledFormGroup = styled(Form.Group) <{ $custom }>`
 .datePicker {
  width: ${props => props.$custom ? '50%' : ''} !important;
 }
`
export const StyledLabel = styled(Label) <{ $firstColor: string }>`
  display: flex !important;
  align-items: center !important;
  margin-bottom: 2em !important;
  width: fit-content !important;
  background-color: ${props => props.$firstColor} !important;
  color: white !important;
  font-style: italic;
  .detail {
    margin-left: 0 !important;
  }
`